<template>
  <div>
    <InitialQuestion
      :save-data="saveData"
      :next-question="nextQuestion"
      :disabled-criteria="disabledCriteria"
    >
      <template v-slot:form>
        <img
          src="@/assets/img/ana.png"
          class="ana_wellcome"
        >
        <br>
        <p class="text-center">
          Hemos recibido tu información. <br>
          Ahora te invitamos a explorar carreras.
        </p>
      </template>
    </InitialQuestion>
  </div>
</template>

<script>
// @ is an alias to /src
import InitialQuestion from '@/components/InitialQuestion.vue';
import $ from 'jquery';

export default {
    name: 'Ana',
    components: {
        InitialQuestion,
    },
    data() {
        return {};
    },
    methods: {
        disabledCriteria() {
            return false;
        },
        nextQuestion() {
            $('.modal').modal('hide');
            this.$nextTick().then(() => {
                this.$router.push({ name: 'explorer' });
            });
        },
        async saveData() {
            return new Promise(((resolve, reject) => {
                setTimeout(() => {
                    resolve('data');
                }, 300);
            }));
        },
    },
};
</script>
<style lang="scss">
.ana_wellcome {
  border-radius: 50%;
  margin-left: auto;
  margin-right: auto;
  display: block;
  height: 50vh;
}
</style>
